/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginApiResponse } from '../../models/login-api-response';
import { LoginRequest } from '../../models/login-request';

export interface PasswordLogin$Params {
      body: LoginRequest
}

export function passwordLogin(http: HttpClient, rootUrl: string, params: PasswordLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginApiResponse>> {
  const rb = new RequestBuilder(rootUrl, passwordLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginApiResponse>;
    })
  );
}

passwordLogin.PATH = '/api/v1/auth/login';
